
import BasePictureTeaserWidget from '../../../../base/components/sidebar/widgets/PictureTeaserWidget.vue'

export default class PictureTeaserWidget extends BasePictureTeaserWidget {}
